// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3VCu","section":"section-La8A","content":"content-28QI"};